import Swiper from "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs";

class CategoryCarousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.startCarousel();
  }

  startCarousel() {
    const swiper = new Swiper(this, {
      slidesPerView: "auto",
      spaceBetween: 10,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}

customElements.define("category-carousel", CategoryCarousel);
